import { _brandBoardDenorm } from './brandBoardDenorm';
import { _defaultBoardTypeDecorator } from './defaultBoardTypeDecorator';

export const _boardDenorm = (o) => _brandBoardDenorm(_defaultBoardTypeDecorator(o));
